/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cron_Monthly_FirstInputs */

const cs_cron_monthly_first = /** @type {(inputs: Cron_Monthly_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Měsíčně 1. v 9:00`)
};

const en_cron_monthly_first = /** @type {(inputs: Cron_Monthly_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly on 1st 9:00`)
};

/**
* | output |
* | --- |
* | "Monthly on 1st 9:00" |
*
* @param {Cron_Monthly_FirstInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const cron_monthly_first = /** @type {((inputs?: Cron_Monthly_FirstInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cron_Monthly_FirstInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cron_monthly_first(inputs)
	return cs_cron_monthly_first(inputs)
});